import SimpleSwitch from './simple-switch.js'
export default [SimpleSwitch]
